import { Pipe, PipeTransform } from '@angular/core';
import { GUEST_STATUS } from '../../../shared/models/events/guest-confirmation-status.model';

@Pipe({ name: 'guestConfirmationStatusTag' })
export class GuestConfirmationStatusTagPipe implements PipeTransform {

  transform(value: any, args?: any): any {
    switch (value) {
      case GUEST_STATUS.PENDING:
        return 'warn';
      case GUEST_STATUS.CONFIRMED:
      // ITSM #1839288: sin `accepted` y `excused`, el invitado que respondia desde la SPA publica
      // caia en el `default` y su etiqueta salia como 'unknown', sin color ni significado.
      case GUEST_STATUS.ACCEPTED:
      case GUEST_STATUS.MANAGE_DELEGATE:
        return 'success';
      case GUEST_STATUS.REJECTED:
      case GUEST_STATUS.EXCUSED:
        return 'danger';
      case GUEST_STATUS.DELEGATED:
        return 'info';
      case GUEST_STATUS.PENDING_APPROVAL:
        return 'contrast';
      default:
        return 'unknown';
    }
  }

}